import {clone, cloneDeepWith, omit} from 'lodash-es';

export function cloneGraphQL<T extends object>(object: unknown): Omit<T, '__typename'> {
  return cloneDeepWith(object, function (value) {
    value = clone(value);

    if (typeof value === 'object') {
      value = omit(value, ['__typename']);
    }

    return value;
  });
}

export function defaultPagination<T extends object>(): T {
  return {
    current_page: 1,
    total: 0,
    per_page: 10,
    data: [],
  } as T;
}
